module.exports = __webpack_public_path__ + "img/VP-Classic_Overview-Rear_1.18c65d29.jpg";